module.exports = new __parcel__URL__("1pi.e2890185.png").toString();